"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = "random/5.0.4";
//# sourceMappingURL=_version.js.map